import CodeBase from "./CodeBase.js"

// User Group 코드 정의 클래스

class UserGroup extends CodeBase {

  constructor() {
    const CODE_MAP = {
      'UGR_00000' : 'Super user',
      'UGR_00001' : '대표계정',
      'UGR_00002' : '사용자',
      };

    super(CODE_MAP);
  }

  isManager(code) {
    if (code === 'UGR_00000' || code === 'UGR_00001') {
      return true;
    }
    return false;
  }
}

export default UserGroup;
